import { ExceptionsEnum } from '@commerce-cart-webcomponents/sdk';

export type ExceptionTitleData = {
  title: string;
  description: string;
};

export const errorImagePath = 'images/CheckoutPageError.svg';

export const ExceptionTextData: {
  [key: string]: ExceptionTitleData;
} = {
  [ExceptionsEnum.Exceptions.ProductService]: {
    title: 'cart.cartContainer.productExecptionTitle',
    description: 'cart.cartContainer.productExecptionDescription',
  },
};

export enum RouteType {
  CART = '/cart',
}
